import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtons } from 'pages/custom/shared/detail/CompanyButtons';
import { S_PageStyle } from 'pages/page/PageStyle';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const HolesovickaTrzniceDemoPage = (props: Props): JSX.Element => {
    return (
        <S_HolesovickaTrzniceDemoPage className={props.className}>
            <CustomMapPage
                mapId={'fc1c6f66-95d3-45ef-9167-d7dc8f815f34'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/e08475b3-e9e2-493f-b43d-0acb9270841c.png',
                    logoText: 'Holešovická Tržnice',
                    linkText: 'Web',
                    link: 'https://www.holesovickatrznice.cz/'
                }}
                mapChildren={<></>}
                interactiveMessage
                controls={<CompanyButtons listTitle="places" exludeHighlight={true} />}
            />
        </S_HolesovickaTrzniceDemoPage>
    );
};

const S_HolesovickaTrzniceDemoPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
